<ng-container *ngIf="type !== 'attribute-count'">
    <div [ngClass]="layoutClass">
        <p-panel *ngIf="!isDialog" [toggleable]="true" [collapsed]="dossiers && dossiers.length == 0">
            <p-header>
                <i class="fa" [ngClass]="typeClass()" aria-hidden="true"></i>
                <ng-container *ngIf="titleKey">{{ titleKey | translate }}</ng-container>
                <ng-container *ngIf="!titleKey">{{ title }}</ng-container>
            </p-header>
            <ng-container *ngTemplateOutlet="table">
            </ng-container>
        </p-panel>
        <p-scrollPanel *ngIf="isDialog" [style]="{width: '100%', height: '60vh'}">
            <div class="container-fluid row">
                <div class="col-12">
                    <ng-container *ngTemplateOutlet="table"></ng-container>
                </div>
            </div>
        </p-scrollPanel>
    </div>
</ng-container>
<ng-template #table>
    <h5 class="leyenda text-center m-n-md">
        <ng-container *ngIf="descriptionKey">{{ descriptionKey | translate }}</ng-container>
        <ng-container *ngIf="!descriptionKey">{{ description }}</ng-container>
    </h5>
    <div *ngIf="!isLoaded()">
        <waitLoading [maxView]="false" *ngIf="!isLoaded()"></waitLoading>
    </div>
    <div *ngIf="isLoaded() && (!dossiers || dossiers.length === 0)" class="no-padding-left  m-b-xs text-ellipsis">
        <div class="alert alert-info m-b-xs text-ellipsis col-12">
            <span>
                <i class="fas fa-1-5x fa-info-circle m-r-md" aria-hidden="true"></i> {{ 'General.noData' | translate
                }}</span>
        </div>
    </div>
    <div *ngIf="isLoaded() && (dossiers && dossiers.length > 0)">
        <div class="card border-0 p-0">
            <div class="card-body p-0">
                <table class="col-12">
                    <thead *ngIf="type === 'attribute'">
                        <tr>
                            <th *ngIf="type == 'lastAccessed' || type == 'favourites' || !this.existColumnsConf">
                                {{'General.exp' | translate}} </th>
                            <ng-container *ngIf="columns && columns.length > 0">
                                <ng-container *ngFor=" let col of columns; let i = index">
                                    <th *ngIf="(this.existColumnsConf || col!='PROPUESTAID' && !col.startsWith('JSON_')) &&
                                    (!this.columnsFormat || !this.columnsFormat[col] || this.columnsFormat[col].columnType!=='hidden')"
                                        [ngClass]="this.columnsFormat&&this.columnsFormat[col]&&this.columnsFormat[col].columnStyleClass?this.columnsFormat[col].columnStyleClass:''">
                                        {{this.getColumnName(col,i)}} </th>
                                </ng-container>
                            </ng-container>
                        </tr>
                    </thead>
                    <tbody class="p-table-tbody">
                        <tr #rowElem
                            *ngFor="let element of dossiers | slice:pageFirst:pageFirst+(pageSize?pageSize:999999999)"
                            style="cursor:pointer;">
                            <ng-container *ngIf="type == 'lastAccessed' || type == 'favourites' ||
                                !this.existColumnsConf">
                                <td (click)="openDossier(element.project)">
                                    <divisionDetail [project]="element.project" [infoLink]="true" [infoTitulo]="true"
                                        [parentElement]="rowElem" class="d-inline text-truncate float-left p-0"
                                        style="min-width: 50%;"></divisionDetail>
                                </td>
                            </ng-container>
                            <ng-container *ngFor=" let col of columns">
                                <ng-container *ngIf="columns && columns.length > 0 && !col.startsWith('JSON_')">
                                    <ng-container *ngIf="!this.columnsFormat || !this.columnsFormat[col]
                                    || this.columnsFormat[col].columnType!=='hidden'">
                                        <td (click)="openDossier(element.project)" *ngIf="(this.existColumnsConf && this.columnsFormat[col].columnType
                                        && this.columnsFormat[col].columnType=='dossierLink')">
                                            <divisionDetail [project]="element.project" [infoLink]="true"
                                                [infoTitulo]="true" [parentElement]="rowElem"
                                                class="d-inline text-truncate float-left p-0" style="min-width: 50%;">
                                            </divisionDetail>
                                        </td>
                                        <td *ngIf="(!this.existColumnsConf&&col!='PROPUESTAID'&&!col.startsWith('JSON_'))
                                        || (this.existColumnsConf &&( !this.columnsFormat[col].columnType || (this.columnsFormat[col].columnType!='action'
                                        &&  this.columnsFormat[col].columnType!='dossierLink' &&  this.columnsFormat[col].columnType!='progress') ))"
                                            [ngClass]="this.columnsFormat&&this.columnsFormat[col]&&this.columnsFormat[col].columnStyleClass?this.columnsFormat[col].columnStyleClass:''"
                                            data-toggle="tooltip" title="{{element[col]}}"> {{element[col]}} </td>
                                        <td *ngIf="this.existColumnsConf&&this.columnsFormat&&this.columnsFormat[col] && this.columnsFormat[col].columnType
                                        && this.columnsFormat[col].columnType=='progress'"
                                            [ngClass]="this.columnsFormat&&this.columnsFormat[col]&&this.columnsFormat[col].columnStyleClass?this.columnsFormat[col].columnStyleClass:''"
                                            data-toggle="tooltip" title="{{element[col]}}"> <p-progressBar
                                                [value]="element[col]"></p-progressBar></td>
                                        <td *ngIf="this.existColumnsConf&&this.columnsFormat&&this.columnsFormat[col] && this.columnsFormat[col].columnType
                                        && this.columnsFormat[col].columnType=='action' && this.columnsFormat[col].actionType
                                        && this.columnsFormat[col].actionType=='documentLink'"
                                            [ngClass]="this.columnsFormat&&this.columnsFormat[col]&&this.columnsFormat[col].columnStyleClass?this.columnsFormat[col].columnStyleClass:''">
                                            <button class="btn btn-primary btn-sm d-inline float-right "
                                                aria-expanded="false" title="{{ 'DocumentsAction.view' | translate }}"
                                                (click)=this.showDocument(element[col])>
                                                <i class="{{this.columnsFormat[col].actionIcon}}"
                                                    aria-hidden="true"></i>
                                            </button>
                                        </td>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                            <td>
                                <button *ngIf="showDeleteButton"
                                    class="btn btn-sm btn-outline p-0 d-inline float-right color-grey"
                                    aria-expanded="false" title="{{ 'General.delete' | translate }}"
                                    (click)="delete(element.identifier)">
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p-paginator [rows]="pageSize" totalRecords="{{dossiers.length}}" (onPageChange)="paginate($event)">
                </p-paginator>
            </div>
        </div>
    </div>
</ng-template>
<div *ngIf="type === 'attribute-count'">
    <a (click)="openModalWidget()">
        <div class="widget col-12" [ngClass]="widgetClass()">
            <ng-container *ngIf="isLoaded()">
                <div class="col-4">
                    <i class="fa fa-5x" [ngClass]="icon"></i>
                </div>
                <div class="col-8 float-right">
                    <ng-container *ngIf="titleKey">{{ titleKey | translate }}</ng-container>
                    <ng-container *ngIf="!titleKey">{{ title }}</ng-container>
                    <h2 class="font-bold">{{ dossiers.length }}</h2>
                </div>
            </ng-container>
            <ng-container *ngIf="!isLoaded()">
                <waitLoading></waitLoading>
            </ng-container>
            <ng-container *ngIf="error">
                <div class="col-lg-12 alert alert-info ">
                    <span class="fa-stack fa-lg">
                        <i class="fa fa-circle-o fa-stack-2x" aria-hidden="true"></i>
                        <i class="fa fa-info fa-stack-1x" aria-hidden="true"></i>
                    </span> {{ 'Widget.error' | translate }}
                </div>
            </ng-container>
        </div>
    </a>
</div>